import { useParams } from 'react-router-dom'
import ServiceInvoices from '../../Templates/shared/ServiceInvoices'

const Receipt = () => {
    const { id: serviceID } = useParams()
    return <ServiceInvoices serviceID={Number(serviceID)} />
}

export default Receipt
